import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        navigate("/login");
        return;
      }
      const sessionId = decodeURIComponent(match[1]);
      try {
        const user = await exchangeSession(sessionId);
        setUser(user);
        // Clean URL fragment
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { state: { user }, replace: true });
      } catch (err) {
        console.error("Auth exchange failed", err);
        navigate("/login", { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div
      data-testid="auth-callback-loader"
      className="min-h-screen flex items-center justify-center bg-[#0A1628] text-[#F5F1E8]"
    >
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 rounded-full border-2 border-[#C9A961] border-t-transparent animate-spin" />
        <p className="font-display text-sm tracking-[0.3em] uppercase text-[#9AA5B5]">
          Forging your session
        </p>
      </div>
    </div>
  );
}
